import { Component, OnInit, ViewChild, AfterViewInit, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from 'src/app/services/storage.service';
import { UtilsService } from 'src/app/utils/utils.service';
import { Empresa } from 'src/app/classes/Empresa';
import { CustomToastyService } from 'src/app/theme/shared/components/toasty/custom-toasty.service';
import { SolicitacaoComprasDTO } from 'src/app/classes/SolicitacaoComprasDto';
import { SyncGridComponent } from '../../shared-farm/sync-grid/sync-grid.component';
import { ColumnModel, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { FormsSolicitacaoCompraComponent } from './forms-solicitacao-compra/forms-solicitacao-compra.component';
import { SolicitacaoCompraService } from 'src/app/services/solicitacao-compra.service';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-solicitacao-compra',
  templateUrl: './solicitacao-compra.component.html',
  styleUrls: ['./solicitacao-compra.component.scss']
})
export class SolicitacaoCompraComponent implements OnInit, AfterViewInit {
  @ViewChild('FormsSolicitacaoCompra', { static: false }) FormsSolicitacaoCompra: FormsSolicitacaoCompraComponent;
  @ViewChild('gridSolicitacoes', { static: false }) gridSolicitacoes: SyncGridComponent;

  isPlanejada: boolean = true;
  tituloContexto: string = "Solicitação de Compras";

  carregando: boolean = false;
  solicitacoes: SolicitacaoComprasDTO[] = [];
  solicitacoesFiltradas: SolicitacaoComprasDTO[] = [];
  exibirConcluidos: boolean = false;
  solicitacaoSelecionadaId: number;
  solicitacaoSelecionadaFull: SolicitacaoComprasDTO;
  
  columns: ColumnModel[] = [];
  gridHeight: string = '70vh';
  pageSettings: PageSettingsModel = {
    pageSizes: [10, 20, 30, 40, 50, 100],
    pageSize: 20,
    pageCount: 4,
  };
  idEmpresa: number;
  empresaLogada: Empresa;

  constructor(
    private storageService: StorageService,
    public utils: UtilsService,
    private toasty: CustomToastyService,
    private router: Router,
    private route: ActivatedRoute,
    private solicitacaoService: SolicitacaoCompraService
  ) { }

  ngOnInit() {
    this.empresaLogada = this.storageService.getEmpresa();
    if (this.empresaLogada && !this.empresaLogada.AcessoSolicitacaoCompra) {
      this.utils.handleWarning('Esta empresa não possui acesso ao módulo de Solicitação de Compras.');
      this.router.navigate(['/mapa']);
      return;
    }

    if (!this.utils.verificarPermissaoUsuario('VisualizarSolicitacaoCompras')) {
      this.utils.handleWarning('Você não tem permissão de acesso a essa funcionalidade!');
      this.router.navigate(['/mapa']);
      return;
    }

    this.idEmpresa = this.storageService.getEmpresa().Id;

    this.route.data.subscribe(data => {
      this.isPlanejada = data['isPlanejada'] !== false;
      this.tituloContexto = data['title'] || "Solicitação de Compras";
    });
    
    this.inicializarColunas();
    this.carregarSolicitacoes();
    this.configurarGrid();
  }

  carregarSolicitacoes() {
    this.carregando = true;
    this.solicitacaoService.getSolicitacoesByTipo(this.isPlanejada)
      .pipe(finalize(() => this.carregando = false))
      .subscribe({
        next: (ret) => {
          this.solicitacoes = ret;
          this.solicitacoes.forEach(s => s.StatusNome = this.getStatusName(s.Status));
          this.filtrarSolicitacoes();

          if (this.solicitacoesFiltradas.length > 0 && !this.solicitacaoSelecionadaId) {
            this.solicitacaoSelecionadaId = this.solicitacoesFiltradas[this.solicitacoesFiltradas.length - 1].Id;
            this.onSolicitacaoChange();
          }
        },
        error: (err) => this.utils.getErro(err)
      });
  }

  onSolicitacaoChange() {
    if (!this.solicitacaoSelecionadaId) {
      this.solicitacaoSelecionadaFull = null;
      return;
    }

    this.carregando = true;
    this.solicitacaoService.getSolicitacaoById(this.solicitacaoSelecionadaId)
      .pipe(finalize(() => this.carregando = false))
      .subscribe({
        next: (ret) => {
          console.debug(`onSolicitacaoChange`,ret)
          this.solicitacaoSelecionadaFull = ret;
        },
        error: (err) => this.utils.getErro(err)
      });
  }

  ngAfterViewInit() {
    this.calcularAlturaGrid();
  }

  inicializarColunas() {
    this.columns = [
      { type: 'checkbox', width: 50 },
      { field: 'DescricaoGrupoProduto', headerText: 'Grupo de Produto', allowSorting: true },
      { field: 'ProdutoDescricao', headerText: 'Produto', allowSorting: true },
      { field: 'PrincipioAtivo', headerText: 'Princípio Ativo', allowSorting: true },
      { field: 'UnidadeMedida', headerText: 'Unid.', width: 80 },
      { field: 'AreaTotal', headerText: 'Área Total (ha)', textAlign: 'Right', format: 'N2' },
      { field: 'Dose', headerText: 'Dose Média', textAlign: 'Right', format: 'N2' },
      { field: 'NumeroAplicacoes', headerText: 'Nº de Aplicações', textAlign: 'Right' },
      { field: 'QuantidadeTotal', headerText: 'Qtd. Total', textAlign: 'Right', format: 'N2' },
      { field: 'EstoqueAtual', headerText: 'Estoque Atual', textAlign: 'Right', format: 'N2' },
      { field: 'QuantoComprar', headerText: 'Qtd a Comprar', textAlign: 'Right', format: 'N2' },
      { field: 'PrecoUnitarioMedio', headerText: 'Preço Unitário Médio', textAlign: 'Right', format: 'C2' },
      { field: 'ValorMedioHa', headerText: 'Valor/ha Estimado', textAlign: 'Right', format: 'C2' },
      { field: 'ValorTotal', headerText: 'Valor Total', textAlign: 'Right', format: 'C2' }
    ];
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.ajustarTamanhoGrid();
  }

  ajustarTamanhoGrid(): void {
    setTimeout(() => {
      const navbar = document.querySelector('app-nav-bar.navbar.pcoded-header') as HTMLElement;
      const title = document.querySelector('h5') as HTMLElement;
      const filter = document.querySelector('.bg-white.border.p-2.mb-0') as HTMLElement;
      const toolbar = document.querySelector('.custom-toolbar') as HTMLElement;
      const pager = document.querySelector('.e-gridpager') as HTMLElement;
      
      const offset = 70; // Compensação baseada na tela de cultivar
      
      const altura = window.innerHeight 
        - (navbar ? navbar.offsetHeight : 0) 
        - (title ? title.offsetHeight : 0) 
        - (filter ? filter.offsetHeight : 0) 
        - (toolbar ? toolbar.offsetHeight : 0) 
        - (pager ? pager.offsetHeight : 0) 
        - offset;

      this.gridHeight = `${Math.max(altura, 400)}px`;
    }, 100);
  }

  configurarGrid(): void {
    if (window.innerHeight <= 1000) {
      this.pageSettings.pageSize = 20;
    } else {
      this.pageSettings.pageSize = 40;
    }
    this.ajustarTamanhoGrid();
  }

  calcularAlturaGrid() {
    this.ajustarTamanhoGrid();
  }

  abrirModalNovaSolicitacao() {
    if (!this.utils.verificarPermissaoUsuario('CriarSolicitacaoCompras')) return;
    this.FormsSolicitacaoCompra.abrirModal();
  }

  exportar(): void{
    if (!this.utils.verificarPermissaoUsuario('PermitirExportarSolicitacaoCompras')) return;
    this.utils.getConfirma('Você tem certeza desta ação?', 'Você tem certeza que deseja exportar esse Solicitação de Compras? Essa ação pode demorar um pouco.').then((confirma) => {
      if (confirma) {
        this.gridSolicitacoes.excelExport();
        Swal.fire(
          'Plano de Contas exportado com sucesso!',
          'A exportação foi realizada com sucesso e já sendo baixada. Procure na listagem de Downloads do seu navegador ou na pasta de destino.',
          'success'
        );
      }
    });
  }

  cancelar(): void{
    if (!this.utils.verificarPermissaoUsuario('CancelarSolicitacaoCompras')) return;
    const selecionado = this.solicitacoes.find(s => s.Id === this.solicitacaoSelecionadaId);
    if (!selecionado) {
      this.utils.handleWarning('Selecione uma solicitação para cancelar.');
      return;
    }

    this.utils.getConfirma('Cancelar Solicitação', 'Deseja realmente cancelar esta solicitação?').then((confirma) => {
      if (confirma) {
        this.carregando = true;
        this.solicitacaoService.cancelarSolicitacoes([this.solicitacaoSelecionadaId])
          .pipe(finalize(() => this.carregando = false))
          .subscribe({
            next: () => {
              this.utils.handleSuccess('Solicitação cancelada com sucesso!');
              this.carregarSolicitacoes();
              this.onSolicitacaoChange();
            },
            error: (err) => this.utils.getErro(err)
          });
      }
    });
  }

  editarSolicitacao(step: number = 1) {
    if (!this.utils.verificarPermissaoUsuario('EditarSolicitacaoCompras')) return;
    if (!this.solicitacaoSelecionadaFull) {
      this.utils.handleWarning('Selecione uma solicitação para editar.');
      return;
    }
    console.debug(`editarSolicitacao`,this.solicitacaoSelecionadaFull)
    this.FormsSolicitacaoCompra.abrirModal(this.solicitacaoSelecionadaFull, step);
  }

  async excluirSolicitacao() {
    if (!this.utils.verificarPermissaoUsuario('ExcluirSolicitacaoCompras')) return;
    if (!this.solicitacaoSelecionadaId) {
      this.utils.handleWarning('Selecione uma solicitação para excluir.');
      return;
    }

    const confirma = await this.utils.getConfirma('Excluir Solicitação', 'Deseja realmente excluir esta solicitação?');
    if (confirma) {
      this.carregando = true;
      this.solicitacaoService.deleteSolicitacao(this.solicitacaoSelecionadaId)
        .pipe(finalize(() => this.carregando = false))
        .subscribe({
          next: () => {
            this.utils.handleSuccess('Solicitação excluída com sucesso!');
            this.solicitacaoSelecionadaId = null;
            this.onSolicitacaoChange();
            this.carregarSolicitacoes();
          },
          error: (err) => this.utils.getErro(err)
        });
    }
  }

  finalizarSave() {
    this.carregarSolicitacoes();
  }

  getItensSelecionados() {
    return this.solicitacaoSelecionadaFull ? this.solicitacaoSelecionadaFull.ItensSolicitacaos : [];
  }

  getStatusClass(): string {
    if (!this.solicitacaoSelecionadaFull) return 'badge-secondary';
    switch (this.solicitacaoSelecionadaFull.Status) {
      case 0: return 'badge-info';    // Planejamento
      case 1: return 'badge-warning'; // Solicitado / Em Cotação
      case 2: return 'badge-primary'; // Em Ordem de Compras
      case 3: return 'badge-success'; // Finalizado
      case 4: return 'badge-danger';  // Cancelado
      default: return 'badge-secondary';
    }
  }

  getStatusTexto(): string {
    if (!this.solicitacaoSelecionadaFull) return '---';
    return this.getStatusName(this.solicitacaoSelecionadaFull.Status);
  }

  getStatusName(status: number): string {
    switch (status) {
      case 0: return 'Em Planejamento';
      case 1: return 'Em Cotação';
      case 2: return 'Em Ordem de Compras';
      case 3: return 'Finalizado';
      case 4: return 'Cancelado';
      default: return 'DESCONHECIDO';
    }
  }

  toggleConcluidos(event: any): void {
    this.exibirConcluidos = event.target.checked;
    this.filtrarSolicitacoes();
  }

  filtrarSolicitacoes(): void {
    if (this.exibirConcluidos) {
      this.solicitacoesFiltradas = [...this.solicitacoes];
    } else {
      this.solicitacoesFiltradas = this.solicitacoes.filter(s => s.Status !== 3 && s.Status !== 4);
      
      // Se a solicitação selecionada não está mais na lista, limpa a seleção
      if (this.solicitacaoSelecionadaId && !this.solicitacoesFiltradas.find(s => s.Id === this.solicitacaoSelecionadaId)) {
        this.solicitacaoSelecionadaId = null;
        this.onSolicitacaoChange();
      }
    }
  }
}
